import React from "react";
import { Link } from "react-router-dom";
import "./topbar.css";

const Topbar = ({ handleSidebar }) => {


  return (
    <>

      <nav className="navbar navbar-main navbar-expand-lg border-bottom topbar d-block d-sm-none p-3">
        <li className="nav-item ps-3 d-flex align-items-center"
          onClick={handleSidebar}
          style={{ cursor: "pointer" }}
        >
          <span className="nav-link text-body p-0">
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
            </div>
          </span>
        </li>
        {/* <li className="navbar-brand m-0 d-flex justify-content-center align-items-center">
          <img
            src="/img/moneymatchlogo.png"
            className="resp-logo"
            alt="Logo"
          />
        </li> */}

        {/* <div className="navbar-brand m-0 d-flex justify-content-center align-items-center">
          
        </div> */}
      </nav>




      <nav className="navbar navbar-main navbar-expand-lg border-bottom topbar d-none d-sm-block">
        <div className="container-fluid py-1 px-3">
          <div
            className="d-none d-lg-inline text-white"
            style={{ fontSize: "17px", textTransform: "capitalize" }}
          >
            Hi, Admin
          </div>
          <div className="collapse navbar-collapse mt-sm-0 mt-2 ml-auto" style={{ flexGrow: "unset" }}>
            <ul className="navbar-nav justify-content-end">
              <li className="nav-item d-flex align-items-center">
                <Link to="/" className="nav-link text-body text-white" style={{ textDecoration: "none" }}>
                  {/* <img
                    src="/img/moneymatchimg.png"
                    className="navbar-brand-img h-100 w-13"
                    alt="Logo"
                    width="30px"
                  /> */}
                  <span style={{ fontSize: "15px" }} className="d-inline text-white ml-1">
                    Log out
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Topbar;
